export default __webpack_public_path__ + "static/media/product31.fce5bce5.png";